<template>
  <div class="welcome-name" v-if="name !== ''">
    <h3>Welcome, {{ name }}</h3>
    <i class="el-icon-user"></i>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useMsal } from "@/api/composition-api/useMsal";

const { accounts } = useMsal();
import WelcomeName from "@/modules/User/WelcomeName.vue";
const name = computed(() => {
  if (accounts?.value.length > 0) {
    const name = accounts?.value[0].name;
    if (name) {
      return name.split(" ")[0];
    }
  }
  return "";
});
</script>

<style scoped>
.welcome-name {
  font-weight: bolder;
}
</style>
